// extracted by mini-css-extract-plugin
export default {"faqQuestions":"FAQQuestions_faqQuestions__RWPnZ","faqItem":"FAQQuestions_faqItem__eRkGT","faqQuestion":"FAQQuestions_faqQuestion__4AFQa","faqAnswer":"FAQQuestions_faqAnswer__J3RLk"};